export const REX_FEATURES_API = '/api/remote_execution_features';
export const NEW_JOB_PAGE = '/job_invocations/new?host_ids%5B%5D';



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_remote_execution-8.0.0-2.fm3_4.el8.noarch/usr/share/gems/gems/foreman_remote_execution-8.0.0/webpack/react_app/components/FeaturesDropdown/constant.js